import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as e, useEffect as i } from "react";

var t = function t() {
  var _e = e(!1),
      _e2 = _slicedToArray(_e, 2),
      t = _e2[0],
      o = _e2[1],
      _e3 = e(!1),
      _e4 = _slicedToArray(_e3, 2),
      n = _e4[0],
      s = _e4[1],
      _e5 = e(!1),
      _e6 = _slicedToArray(_e5, 2),
      r = _e6[0],
      d = _e6[1],
      _e7 = e(!1),
      _e8 = _slicedToArray(_e7, 2),
      w = _e8[0],
      c = _e8[1],
      _e9 = e(!1),
      _e10 = _slicedToArray(_e9, 2),
      l = _e10[0],
      a = _e10[1],
      b = function b() {
    var e = window.innerWidth;
    o(e < 768), s(e >= 768 && e < 1024), d(e >= 1024 && e < 1200), c(1200 <= e), a(e >= 768);
  };

  return i(function () {
    return b(), window.addEventListener("resize", b), function () {
      return window.removeEventListener("resize", b);
    };
  }, []), {
    isMobile: t,
    isTablet: n,
    isDesktop: r,
    isXl: w,
    isNotMobile: l
  };
};

export { t as useScreenRecognition };